// Link clicks for Umami: where a click went and where the link sat. Umami records the pages; this adds which link
// led from one to the next.
// Sent with umami.track, whose keepalive request outlives the page, not with data-umami-event attributes:
// Umami holds a tagged link's navigation until its server answers, with no timeout.

// Where the link sits, not its text: copy and prices change, which would split one button across many
// labels. Umami records the page itself; data-cta names a button that must be told apart within a page.
function placement(a) {
  if (a.dataset.cta) return a.dataset.cta;
  if (a.closest('footer')) return 'footer';
  if (a.closest('nav')) return 'navbar';
  return 'page';
}

document.addEventListener('click', e => {
  const a = e.target.closest('a[href]');
  // No host: mailto:, tel: and javascript: links
  if (!a || !a.host || a.getAttribute('href').startsWith('#')) return;

  if (a.host !== window.location.host) {
    window.umami?.track('outbound-link-click', { url: a.href, placement: placement(a) });
  } else {
    // Encrypted segments (checkout links are /b/<token>) would make every click its own destination
    const path = a.pathname.replace(/\/[^/]{64,}/g, '/:token');
    window.umami?.track('internal-link-click', { path, placement: placement(a) });
  }
});
